import { render, staticRenderFns } from "./PrintCalendarIA.vue?vue&type=template&id=55b286bb&"
import script from "./PrintCalendarIA.vue?vue&type=script&lang=js&"
export * from "./PrintCalendarIA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports